export const enum breakpoints {
  phone = 600,
  tablet = 900,
  desktop = 1200,
}
